const topics = [
  { name: '娱乐圈爆料', count: 1286, hot: true },
  { name: '网红翻车现场', count: 952, hot: true },
  { name: '明星八卦合集', count: 873, hot: true },
  { name: '社会事件披露', count: 654, hot: false },
  { name: '直播带货雷区', count: 541, hot: true },
  { name: '综艺幕后揭秘', count: 432, hot: false },
  { name: '资本运作内幕', count: 389, hot: false },
  { name: '法律维权案例', count: 276, hot: false },
  { name: '行业深度扒皮', count: 243, hot: false },
  { name: '年度事件回顾', count: 198, hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              热门<span className="text-primary-500">话题</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              按话题分类浏览，找到你感兴趣的911吃瓜黑料内容
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic, idx) => (
              <div
                key={idx}
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-all duration-200 hover:scale-105 ${
                  topic.hot
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-700 hover:bg-background-200/70'
                }`}
              >
                {topic.hot && (
                  <span className="w-1.5 h-1.5 bg-accent-400 rounded-full animate-pulse"></span>
                )}
                <span className="text-sm font-medium whitespace-nowrap">{topic.name}</span>
                <span className={`text-xs ${topic.hot ? 'text-background-50/70' : 'text-foreground-400'}`}>
                  {topic.count}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}